<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <collapse-portlet :expanded="false" title="Live Feed Configuration">
          <vue-json-pretty :data="liveFeed.premium_config" />
        </collapse-portlet>
      </div>
      <div class="col-12 col-md-6">
        <collapse-portlet :expanded="false" title="Most Recent Log">
          <vue-json-pretty :data="liveFeed.last_log" />
        </collapse-portlet>
      </div>
      <div class="col-12 col-md-6">
        <collapse-portlet :expanded="false" title="Created Log" caption="Log from initial creation">
          <vue-json-pretty :data="liveFeed.last_create_log" />
        </collapse-portlet>
      </div>
      <div class="col-12 col-md-6">
        <collapse-portlet :expanded="false" title="Last Start" caption="Last log from when the 'start' action was called">
          <vue-json-pretty :data="liveFeed.last_start_log" />
        </collapse-portlet>
      </div>

      <div class="col-12 col-md-6">
        <collapse-portlet :expanded="false" title="Last Stop" caption="Last log from when the 'stop' action was called">
          <vue-json-pretty :data="liveFeed.last_stop_log" />
        </collapse-portlet>
      </div>

      <div class="col-12 col-md-6">
        <collapse-portlet :expanded="false" title="Last Restart" caption="Last log from when the 'restart' action was called">
          <vue-json-pretty :data="liveFeed.last_restart_log" />
        </collapse-portlet>
      </div>
    </div>
  </div>
</template>

<script>
import CollapsePortlet from "VueComponents/CollapsePortlet";
import VueJsonPretty from "vue-json-pretty";
import 'vue-json-pretty/lib/styles.css';

export default {
  components: { VueJsonPretty, CollapsePortlet },
  props: {
    liveFeed: {
      type: Object,
      required: true,
    },
  },
};
</script>
